import { MessageProps } from '../homepage/types'
import { Message } from './message'

interface MessageListProps {
  messages: Omit<MessageProps, 'index'>[]
}

export const MessageList = ({ messages }: MessageListProps) => {
  return (
    <div className='flex-grow-1 flex flex-col justify-start'>
      {messages.map((message, index) => (
        <div key={message.id}>
          <Message key={message.id} {...message} index={index} className='shadow-md' />
        </div>
      ))}
    </div>
  )
}
